import * as React from 'react'
import { lightTheme } from '@/customTheme'

type IconProps = {
  disabled?: boolean
  size?: number
}

function ResizeSuggestIcon({ disabled, size = 24 }: IconProps) {
  const color = disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <g transform="translate(3 3)">
        <path
          d="M8.39453 3.75C8.88383 3.74869 9.28263 4.14444 9.28418 4.63379C9.2856 5.12314 8.88878 5.52086 8.39941 5.52246L6.77637 5.52734L12.4756 11.2266L12.4775 9.60645C12.4783 9.11713 12.8759 8.72016 13.3652 8.7207C13.8544 8.7215 14.2503 9.11922 14.25 9.6084L14.2461 12.8271C14.2452 13.608 13.6129 14.2417 12.832 14.2441L9.60547 14.2549C9.11619 14.2562 8.71741 13.8604 8.71582 13.3711C8.71435 12.8817 9.11119 12.484 9.60059 12.4824L11.2236 12.4766L5.52344 6.77637L5.52246 8.39844C5.52166 8.88772 5.12411 9.28472 4.63477 9.28418C4.14563 9.28339 3.74969 8.88563 3.75 8.39648L3.75391 5.17676C3.75501 4.39611 4.38727 3.76319 5.16797 3.76074L8.39453 3.75Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8789 0C15.9109 0.0000819094 16.6866 0.259848 17.2061 0.779297C17.7324 1.29883 17.9961 2.06836 17.9961 3.08691V14.9199C17.996 15.9382 17.7323 16.7042 17.2061 17.2168C16.6866 17.7361 15.9107 17.996 14.8789 17.9961H3.11719C2.09212 17.9961 1.3164 17.736 0.790039 17.2168C0.263756 16.7042 0.000084101 15.9382 0 14.9199V3.08691C0 2.06836 0.263672 1.29883 0.790039 0.779297C1.3164 0.259928 2.09196 0 3.11719 0H14.8789ZM3.18945 1.74316C2.72476 1.74316 2.36913 1.86637 2.12305 2.1123C1.87695 2.3584 1.75391 2.72461 1.75391 3.20996V14.7969C1.75399 15.2751 1.87704 15.6378 2.12305 15.8838C2.36912 16.1296 2.72492 16.2529 3.18945 16.2529H14.8066C15.2645 16.2529 15.6201 16.1297 15.873 15.8838C16.1259 15.6378 16.2528 15.2751 16.2529 14.7969V3.20996C16.2529 2.72461 16.126 2.3584 15.873 2.1123C15.6201 1.86621 15.2646 1.74316 14.8066 1.74316H3.18945Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default ResizeSuggestIcon
